














































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { EnquiryProduct } from '@/models/enquiry-product';
import { EnquiryApi } from '@/api/enquiry-api';
import { Enquiry } from '@/models/enquiry';
import { EnquiryDocument } from '@/models/enquiry-document';
import { EnquiryHistory } from '@/models/enquiry-history';
import { isFileTypeValid, isFileSizeValue } from '@/file-validator';
import { namespace } from 'vuex-class';
import enquiryStatusLabel from '@/components/enquiry-status-label.vue';
import enquiryHistoryDescription from '@/components/enquiry-history-description.vue';
import { Permissions } from '@/models/permission-constants';
import { EnquiryComment } from '@/models/enquiry-comment';

const UserModule = namespace('user');
const enquiryApi = new EnquiryApi();

@Component({
    components: {
        enquiryStatusLabel,
        enquiryHistoryDescription,
    },
})
export default class EnquiryDetails extends Vue {
    @Prop({ required: true }) public enquiry: Enquiry;
    @Prop({ required: true }) public documents: Array<EnquiryDocument>;
    @Prop({ required: true }) public comments: Array<EnquiryComment>;
    @Prop({ required: true }) public history: Array<EnquiryHistory>;
    @UserModule.Getter public canViewQuotes: boolean;
    @UserModule.Getter public canCreateQuotes: boolean;
    public products: Array<EnquiryProduct> = this.enquiry.products;
    public commentValue: string | null = null;

    public addDocument(): void {
        (this.$refs.files as HTMLInputElement).click();
    }
    public async fileUploadChanged(): Promise<void> {
        const files = (this.$refs.files as HTMLInputElement).files;

        if (files == null) {
            return;
        }

        const fileUploads: Array<Promise<void>> = [];

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < files.length; i++) {
            if (!isFileTypeValid(files[i])) {
                await (this as any).$alert({ title: 'Error', content: 'This document type cannot be uploaded.', size: 'md', okType: 'danger' });
                (this.$refs.files as HTMLInputElement).value = '';
                return;
            }

            if (!isFileSizeValue(files[i])) {
                await (this as any).$alert({ title: 'Error', content: 'This document is too large to be uploaded. The maximum file size allowed is 10Mb', size: 'md', okType: 'danger' });
                (this.$refs.files as HTMLInputElement).value = '';
                return;
            }

            fileUploads.push(enquiryApi.createDocumentAsync(this.enquiry.id!, files[i]));
        }

        await Promise.all(fileUploads);

        this.$emit('document-uploaded');

        (this.$refs.files as HTMLInputElement).value = '';
    }
    public removeFile(index: number): void {
        this.$emit('document-removed', index);
    }
    public downloadFile(index: number): void {
        this.$emit('document-downloaded', index);
    }
    public addComment(): void {
        this.$emit('comment-added', this.commentValue);
        this.ClearCommentBox();
    }
    public removeComment(index: number): void {
        this.$emit('comment-removed', index);
    }
    public ClearCommentBox(): void {
        this.commentValue = null;
    }
}
